import ApiService from '@/api';
import CheckNamespaceAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/namespace-admins/CheckNamespaceAdminRequest';
import {
  PageRequest,
  ProjectQueueTaskListItem,
  ProjectQueueTaskListRequest,
} from '@/components/tasks-kanban/adapter';
import { TirPmNotificationEventBus, TirPmNotificationModel } from 'tir-components';
import { ResponseModel } from 'tir-pm-file-upload-manager';
import { CurrentUser } from 'tir-pm-user-core';
import { Events } from '@/api/Main/dataSource/api/plugins/events';
import CheckProjectAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/project-admins/CheckProjectAdminRequest';
import GetQueueTaskEmployeeListDetailRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/request/GetQueueTaskEmployeeListDetailRequest';
import { EmployeeAccessModel } from '@/components/edit-queue-modal/models';
import { mapGetUsersAccessResponse } from '@/components/edit-queue-modal/adapter-service/adapter-service.mappers';
import { ParentTaskModel } from '@/components';
import { ProjectQueueTaskGetRequestModel } from '../models';
import ProjectQueueTaskGetResponse from '@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskGetResponse';
export class AdapterService {
  private readonly api = new ApiService();

  UpdateQueueTaskStatusEvent = new Events<ResponseModel<any>>();
  /**
   * * Проверить является ли текущий пользователь админом неймспейса
   * @param namespaceId
   * @returns
   */
  checkNamespaceAdmin(namespaceId: string) {
    return new Promise<boolean>(async (resolve) => {
      await this.api.Main.NamespaceAdminRoleService.checkNamespaceAdminAsync(
        new CheckNamespaceAdminRequest({
          UserId: CurrentUser.Id,
          NamespaceId: namespaceId,
        }),
      )
        .then((resp) => {
          return resolve(resp.IsNamespaceAdmin);
        })
        .catch((e) => {
          console.error(e);
          return resolve(false);
        });
    });
  }

  ToggleSubscribe(isSubscribe: boolean) {
    const func: keyof Events<any> = isSubscribe ? 'on' : 'removeListener';
    this.api.Main.TaskStatusSaveService.UpdateQueueTaskStatusEvent[func](
      this.OnUpdateQueueTaskStatus.bind(this),
    );
  }

  /**
   * Получение информации об очереди
   * @param queueId
   * @returns
   */
  getQueueInfo(
    request: ProjectQueueTaskGetRequestModel,
  ): Promise<ResponseModel<ProjectQueueTaskGetResponse>> {
    return new Promise<ResponseModel<ProjectQueueTaskGetResponse>>(async (resolve) => {
      const result = new ResponseModel<ProjectQueueTaskGetResponse>();
      await this.api.Main.ProjectQueueTaskService.getAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((error) => {
          console.error(error);
          result.IsSuccess = false;
          result.ErrorCode = error.ErrorCode;
          resolve(result);
        });
    });
  }

  OnUpdateQueueTaskStatus(response: any) {
    this.UpdateQueueTaskStatusEvent.trigger(response);
  }
  async isProjectAdmin(req: CheckProjectAdminRequest): Promise<ResponseModel<Boolean>> {
    const result = new ResponseModel<Boolean>();

    try {
      const response = await this.api.Main.ProjectAdminRoleService.checkProjectAdminAsync(req);
      result.Value = response.IsProjectAdmin;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR checkProjectAdminAsync', e);
    }

    return result;
  }
  /**Получение родительской задачи очереди */
  async getQueueParentTask(queueId: string) {
    return new Promise<ResponseModel<ParentTaskModel>>(async (resolve) => {
      const result = new ResponseModel<ParentTaskModel>();
      await this.api.Main.ProjectQueueTaskService.getQueueParentTaskAsync({ QueueTaskId: queueId })
        .then((response) => {
          result.Value = new ParentTaskModel({ ...response });
          resolve(result);
        })
        .catch((error) => {
          console.error(error);
          result.IsSuccess = false;
          result.ErrorCode = error.ErrorCode;
          resolve(result);
        });
    });
  }
  /**Получение детальной информации о списке сотрудников рабочей области с доступами по очереди задач */
  async getQueueUsersRoles(
    req: GetQueueTaskEmployeeListDetailRequest,
  ): Promise<ResponseModel<EmployeeAccessModel[]>> {
    const result = new ResponseModel<EmployeeAccessModel[]>();

    try {
      const response =
        await this.api.Main.QueueTaskAdminRoleService.getQueueTaskEmployeeListDetailAsync(req);
      result.Value = mapGetUsersAccessResponse(response);
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR getOwnedUsersAsync', e);
    }

    return result;
  }
  sendErrorNotification(message: string) {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: message,
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  }
}
